import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconInstagram = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      className={`${classes}`}
      styles={styles}
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      id='Layer_1'
    >
      <title>Instagram</title>
      <Path
        color={color}
        d='M43.44,21.71h-14.88c-3.73,0-6.76,3.03-6.76,6.76v14.88c0,3.73,3.03,6.76,6.76,6.76h14.88c3.73,0,6.76-3.03,6.76-6.76v-14.88c0-3.73-3.03-6.76-6.76-6.76ZM36,44.76c-4.88,0-8.84-3.97-8.84-8.84s3.97-8.84,8.84-8.84,8.84,3.97,8.84,8.84-3.97,8.84-8.84,8.84ZM45.08,28.88c-1.14,0-2.07-.93-2.07-2.07s.93-2.07,2.07-2.07,2.07.93,2.07,2.07-.93,2.07-2.07,2.07ZM36,30.08c-3.21,0-5.83,2.62-5.83,5.83s2.62,5.83,5.83,5.83,5.83-2.62,5.83-5.83-2.62-5.83-5.83-5.83ZM36,8.37c-15.21,0-27.54,12.33-27.54,27.54s12.33,27.54,27.54,27.54,27.54-12.33,27.54-27.54-12.33-27.54-27.54-27.54ZM53.21,43.35c0,5.39-4.38,9.77-9.77,9.77h-14.88c-5.39,0-9.77-4.38-9.77-9.77v-14.88c0-5.39,4.38-9.77,9.77-9.77h14.88c5.39,0,9.77,4.38,9.77,9.77v14.88Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
